// src/config.js
export const adminUsers = [
  'admin@example.com',
  'commandalps@gmail.com', // Added your email
  // Add other admin emails here
];
